// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Form inputs.
 */

.form-control:focus {
  border-color: var(--gh-accent-fg);
  box-shadow: 0 0 0 3px rgba(9, 105, 218, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/styles/forms.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,iCAAiC;EACjC,4CAA4C;AAC9C","sourcesContent":["/*\n * Form inputs.\n */\n\n.form-control:focus {\n  border-color: var(--gh-accent-fg);\n  box-shadow: 0 0 0 3px rgba(9, 105, 218, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
